export default "__VITE_ASSET__DdKBxQ1n__"